import { render, staticRenderFns } from "./WorkspaceTableColumns.vue?vue&type=template&id=7e0ad27c"
import script from "./WorkspaceTableColumns.vue?vue&type=script&lang=ts"
export * from "./WorkspaceTableColumns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports